import { RefObject, useEffect, useRef, useState } from "react"

export const useIntersection = (element: RefObject<HTMLDivElement>, rootMargin?: string, threshold?: number, minimumViewTime?: number) => {
  const [isVisible, setState] = useState(false)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (!element.current) {
      return
    }

    const el = element.current

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (minimumViewTime && minimumViewTime > 0) {
            timeoutRef.current = setTimeout(() => {
              setState(true)
            }, minimumViewTime)
          } else {
            setState(true)
          }
        } else {
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
            timeoutRef.current = null
          }
          setState(false)
        }
      },
      { rootMargin, threshold }
    )

    observer.observe(el)

    return () => {
      observer.unobserve(el)
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [element, rootMargin, threshold, minimumViewTime])

  return isVisible
}
